// CO - Tamanho começa sem seleção na PDP.
//
// O picker do Horizon sempre tem uma variante marcada (o fluxo inteiro — troca de
// cor, preço, galeria, morph — depende disso), então o input de tamanho continua
// marcado por baixo. O que muda:
//   1. fieldset de tamanho ganha `data-conso-tam-pendente` até o cliente clicar num
//      tamanho; o CSS (conso-tamanho-pendente.css) faz o botão marcado parecer comum.
//   2. o clique no "Adicionar ao carrinho" (name="add", inclusive o `.click()` da
//      barra fixa) é barrado em captura no window enquanto houver tamanho pendente.
// O morph da troca de cor re-renderiza o fieldset e apaga o atributo; o
// MutationObserver recoloca antes do paint.
//
// Fora do escopo: pickers dentro de <dialog> (quick add) e os selects próprios do
// kit (conso-oferta-quantidade), que não usam name="add".

(() => {
  if (window.__consoTamanhoPendente) return;
  window.__consoTamanhoPendente = true;

  const OPCAO_TAMANHO = /tamanho|size/i;
  const MSG = 'Selecione um tamanho';
  const escolhidos = new Set();

  const nomeDaOpcao = (fieldset) => fieldset.querySelector('input[data-option-name]')?.dataset.optionName || '';

  const fieldsetsDeTamanho = () =>
    Array.from(document.querySelectorAll('variant-picker fieldset.variant-option')).filter(
      (fieldset) => !fieldset.closest('dialog') && OPCAO_TAMANHO.test(nomeDaOpcao(fieldset))
    );

  const pendentes = () => fieldsetsDeTamanho().filter((fieldset) => fieldset.hasAttribute('data-conso-tam-pendente'));

  function limparErro(fieldset) {
    fieldset.removeAttribute('data-conso-tam-erro');
    fieldset.querySelector('.conso-tam-erro')?.remove();
  }

  function aplicar() {
    for (const fieldset of fieldsetsDeTamanho()) {
      const pendente = !escolhidos.has(nomeDaOpcao(fieldset));
      if (pendente && !fieldset.hasAttribute('data-conso-tam-pendente')) {
        fieldset.setAttribute('data-conso-tam-pendente', '');
      } else if (!pendente && fieldset.hasAttribute('data-conso-tam-pendente')) {
        fieldset.removeAttribute('data-conso-tam-pendente');
        limparErro(fieldset);
      }
    }
  }

  function marcarEscolha(event) {
    const input = event.target.closest?.('label')?.querySelector('input[data-option-name]') ||
      (event.target.matches?.('input[data-option-name]') ? event.target : null);
    if (!input || input.closest('dialog')) return;
    const nome = input.dataset.optionName;
    if (!OPCAO_TAMANHO.test(nome) || escolhidos.has(nome)) return;
    escolhidos.add(nome);
    aplicar();
  }

  function mostrarErro(lista) {
    for (const fieldset of lista) {
      fieldset.removeAttribute('data-conso-tam-erro');
      // reflow pra reiniciar a animação quando o cliente clica de novo
      void fieldset.offsetWidth;
      fieldset.setAttribute('data-conso-tam-erro', '');
      if (!fieldset.querySelector('.conso-tam-erro')) {
        const p = document.createElement('p');
        p.className = 'conso-tam-erro';
        p.setAttribute('role', 'alert');
        p.textContent = MSG;
        fieldset.appendChild(p);
      }
    }
    lista[0].scrollIntoView({ block: 'center', inline: 'nearest', behavior: 'smooth' });
  }

  function barrarAdd(event) {
    const botao = event.target.closest?.('button[name="add"]');
    if (!botao || botao.closest('dialog')) return;
    const lista = pendentes();
    if (lista.length === 0) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    mostrarErro(lista);
  }

  document.addEventListener('click', marcarEscolha, true);
  document.addEventListener('change', marcarEscolha, true);
  window.addEventListener('click', barrarAdd, true);

  const iniciar = () => {
    aplicar();
    new MutationObserver(aplicar).observe(document.body, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
})();
